import { Result } from '@youhelp-ru/core';
import { ROUTER } from '@cp/shared/router';
import { OAuthVariants } from '@common/model/client/oauth/oauthService';
import { OAuthRequest, OAuthRespone } from '@common/model/client/oauth/oauth';
import { IoContainer } from '@cp/shared/di';
import { ClientAuthResponse } from '@common/model/client/auth';
import { AuthError } from 'src/features/auth';
// FIXME upper level import
import { STORE } from 'src/app/redux';
import { coreClientAuthApi } from 'src/entities/client';
import { INTENTION_SERVICE } from 'src/shared/intent';
import { CLIENT_SELECTION_GETTER, DEVICE_IDENTIFIER } from '../di';
import { AuthStrategyImpl } from './types';

type OAuthApi = (r: OAuthRequest) => Promise<OAuthRespone>;

export const createOAuthApi = (container: IoContainer, provider: OAuthVariants): OAuthApi => {
  const store = container.get(STORE);
  switch (provider) {
    case OAuthVariants.Apple:
      return (r) => store.dispatch(coreClientAuthApi.endpoints.appleAuth.initiate(r, { track: false })).unwrap();
    case OAuthVariants.Google:
      return (r) => store.dispatch(coreClientAuthApi.endpoints.googleAuth.initiate(r, { track: false })).unwrap();
    case OAuthVariants.Telegram:
      return (r) => store.dispatch(coreClientAuthApi.endpoints.telegramAuth.initiate(r, { track: false })).unwrap();
    default:
      throw new AuthError('Unsupported OAuth provider');
  }
};

export const createOAuthStrategy = (container: IoContainer, provider: OAuthVariants): AuthStrategyImpl => {
  const router = container.get(ROUTER),
    getClientSelection = container.get(CLIENT_SELECTION_GETTER),
    identifyDevice = container.get(DEVICE_IDENTIFIER),
    intentionService = container.get(INTENTION_SERVICE),
    oauthApi = createOAuthApi(container, provider);

  return async () => {
    if (!provider) {
      return Result.Err(new AuthError('Missed OAuth provider'));
    }
    const res = await Result.fromAsync(
      async () => {
        return oauthApi({
          additionalFields: await getClientSelection(),
          redirectUrl: intentionService.injectIntention(new URL(router.location.href)).toString(),
          deviceId: await identifyDevice(),
        });
      },
      () => new AuthError('OAuth request error'),
    );
    const r = await res.mapAsync(({ url }) => router.navigate(url, { method: 'replace' }));
    return r.map((): ClientAuthResponse => ({ isRegistered: false })).flatMap(() => Result.Err(new AuthError('OAuthRedirect')));
  };
};
